<!-- Landing loading skeleton -->
<!-- During the payment flow we navigate directly to this screen
For that we make the billing balance call so we also display 
it's loading skeleton.
The loading skeleton of the overview is below and will be displayed
with the transactions call -->
<my-bill-odb-page-base-structure
  [hasTopContent]="true"
  *ngIf="isBalanceLoadingSkeletonDisplayed"
  [hasCustomHeader]="true"
>
  <my-bill-overview-header
    customHeader
    [testId]="'mybillOverviewTitle'"
    [mainTitle]="mainTitle"
    [shouldDisplayBackButton]="false"
  ></my-bill-overview-header>
  <my-bill-landing-skeleton topContent> </my-bill-landing-skeleton>
</my-bill-odb-page-base-structure>

<!-- Empty install base or landing error-->
<my-bill-odb-page-base-structure
  [hasCustomHeader]="true"
  [hasTopContent]="true"
  *ngIf="
    (hasEmptyInstallbase$ | async) ||
    hasBalanceFetchingError ||
    (hasBalanceFetchingError && hasTransactionsOrPaymentInfoFetchingError) ||
    isUr
  "
>
  <my-bill-overview-header
    customHeader
    [testId]="'mybillOverviewTitle'"
    [mainTitle]="mainTitle"
    [shouldDisplayBackButton]="false"
  ></my-bill-overview-header>
  <ng-container [ngTemplateOutlet]="messageBox" topContent></ng-container>
</my-bill-odb-page-base-structure>

<!-- Overview content -->
<my-bill-odb-page-base-structure
  [hasCustomHeader]="true"
  [leftColumnClassWidth]="'medium-8'"
  [rightColumnClassWidth]="'medium-4'"
  [shouldGoBackToOverview]="true"
  *ngIf="
    !hasBalanceFetchingError &&
      !isBalanceLoadingSkeletonDisplayed &&
      (hasEmptyInstallbase$ | async) === false &&
      !hasTransactionsOrPaymentInfoFetchingError &&
      !isOverviewLoadingSkeletonDisplayed &&
      selectedBillingAccount$ | async
  "
>
  <ng-container customHeader>
    <my-bill-overview-header
      [testId]="'mybillOverviewTitle'"
      [mainTitle]="mainTitle"
      [shouldDisplayBackButton]="isAccountSelectedWithMoreThanOneAccount"
      [shouldShowAccountSelection]="true"
      [billingAccounts]="billingAccounts"
    ></my-bill-overview-header>
    <my-bill-evolution-tab
      [isEvolutionTabActive]="false"
      *ngIf="
        billingAccounts &&
        billingAccounts.length === 1 &&
        isEvolutionScreenReady
      "
    ></my-bill-evolution-tab>
  </ng-container>

  <ng-container leftColumnContent>
    <!-- payment status -->
    <ng-container
      [ngTemplateOutlet]="messageBox"
      *ngIf="paymentMade || paymentDataCallFailedStatus"
    ></ng-container>
    <my-bill-billing-account-container
      [billingAccount]="selectedBillingAccount"
      [isSelectedBillingAccountView]="true"
      [customerAccount]="customerAccount"
    >
    </my-bill-billing-account-container>
  </ng-container>

  <div class="rs-panel-big rs-bg-c2 clearfix" rightColumnContent>
    <my-bill-faq-settings-container
      [billingDocument]="billingDocument"
      [billingAccount]="billingAccount"
      [customerAccount]="customerAccount"
      [zone]="'mybill.overview'"
      [isResUser]="isResUser"
    ></my-bill-faq-settings-container>
  </div>
</my-bill-odb-page-base-structure>

<!-- Overview loading skeleton -->
<my-bill-odb-page-base-structure
  [hasTopContent]="true"
  *ngIf="
    !isUr &&
    !isBalanceLoadingSkeletonDisplayed &&
    isOverviewLoadingSkeletonDisplayed
  "
  [hasCustomHeader]="true"
>
  <my-bill-overview-header
    [testId]="'mybillOverviewTitle'"
    customHeader
    [mainTitle]="mainTitle"
    [shouldDisplayBackButton]="false"
  ></my-bill-overview-header>
  <my-bill-overview-redesign-skeleton topContent>
  </my-bill-overview-redesign-skeleton>
</my-bill-odb-page-base-structure>

<!-- Overview page error -->
<my-bill-odb-page-base-structure
  [hasCustomHeader]="true"
  [hasTopContent]="true"
  [shouldGoBackToOverview]="true"
  [leftColumnClassWidth]="'medium-8'"
  [rightColumnClassWidth]="'medium-4'"
  *ngIf="hasTransactionsOrPaymentInfoFetchingError && !hasBalanceFetchingError"
>
  <my-bill-overview-header
    [testId]="'mybillOverviewTitle'"
    customHeader
    [mainTitle]="mainTitle"
    [shouldDisplayBackButton]="isAccountSelectedWithMoreThanOneAccount"
  ></my-bill-overview-header>
  <ng-container
    [ngTemplateOutlet]="messageBox"
    leftColumnContent
  ></ng-container>
  <div class="rs-panel-big rs-bg-c2" rightColumnContent>
    <my-bill-faq-settings-container
      [billingDocument]="billingDocument"
      [billingAccount]="billingAccount"
      [customerAccount]="customerAccount"
      [zone]="'mybill.overview'"
      [isResUser]="isResUser"
    ></my-bill-faq-settings-container>
  </div>
</my-bill-odb-page-base-structure>

<ng-template #messageBox>
  <div class="panel rs-no-padding">
    <lib-generic-message-box
      [messageType]="messageBoxType"
      id="messageBoxType"
      [showCross]="paymentMade || paymentDataCallFailedStatus"
      (crossEmitter)="onClose()"
      data-cy="genericMessageBox"
    >
      <ng-container Title *ngIf="messageBoxTitleKey">{{
        messageBoxTitleKey | translate
      }}</ng-container>
      <p Content *ngIf="messageBoxContentKey">
        {{ messageBoxContentKey | translate }}
      </p>
      <span Content [innerHtml]="messageBoxContent" *ngIf="messageBoxContent">
      </span>
    </lib-generic-message-box>
  </div>
</ng-template>
